import { Link } from "@inertiajs/react";
import ApplicationLogo from "./ApplicationLogo";

const GuestFooter = () => {
    return (
        <div className=" dark:bg-secondary-dark">
            <div className="relative max-w-[1440px] m-auto min-h-[100px]">
                <div className="flex justify-between items-center h-[100px] px-[4vw]  md:px-6 2xl:px-0">
                    <div className="text-black">
                        <Link
                            href="/pnp"
                            className="md:text-[20px] font-normal dark:text-text-dark"
                        >
                            Privacy policy
                        </Link>
                    </div>

                    <div className="flex items-center h-[50px]">
                        <Link className=" h-full " href="/">
                            <ApplicationLogo className="block text-gray-200 max-h-[50px] dark:text-text-dark" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GuestFooter;
